import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MaterialTable from "material-table";

import FormEdit from "./FormEdit";
import Detail from "./Detail";
import { getCategories, getPaginateCategories, deleteCategory } from "../../actions/admin/category";
import { updateModalContent, toggleModal } from "../../actions/modal";

const List = ({
    getPaginateCategories,
    deleteCategory,
    updateModalContent,
    toggleModal,
    category: { updatedAt }
}) => {
    const formEditRef = useRef();
    const table = useRef();

    const [pageSize, setPageSize] = useState(5);

    useEffect(() => {
        table.current && table.current.onQueryChange();
    }, [updatedAt])

    const columns = [
        { title: "ID", field: "id", defaultSort: "asc" },
        {
            title: "Name",
            field: "name",
            render: category => {
                return (
                    <span
                        onClick={() => onEditCategory(category)}
                        style={{ cursor: "pointer" }}
                        className="quick-edit"
                    >
                        {category.name}
                    </span>
                );
            }
        },
        { title: "Group", field: "group" }
    ];

    const onDeleteCategory = id => {
        updateModalContent({
            title: "Are you sure?",
            content: "All data related to this category will be deleted.",
            actionButton: {
                actionText: "Yes, Delete!",
                actionType: "danger",
                action: () => deleteCategory(id)
            },
            cancelText: "No",
            closeAfterAction: true
        });

        toggleModal();
    };

    const onEditCategory = category => {
        updateModalContent({
            title: "Update Category",
            content: <FormEdit id={category.id} ref={formEditRef} />,
            actionButton: {
                actionText: "Save",
                actionType: "primary",
                action: () => formEditRef.current.submitForm()
            },
            cancelText: "Cancel",
            closeAfterAction: false
        });

        toggleModal();
    };

    const onViewCategory = category => {
        updateModalContent({
            title: "Category Detail",
            content: <Detail id={category.id} />,
            cancelText: "Close",
            closeAfterAction: true
        });

        toggleModal();
    };

    return (
        <MaterialTable
            tableRef={table}
            title="Category List"
            columns={columns}
            onChangeRowsPerPage={(pageSize) => {
                setPageSize(pageSize)
            }}
            data={query =>
                new Promise(async (resolve, reject) => {
                    try {
                        const result = await getPaginateCategories(query);

                        let { rows, count } = result;
                        // let rows = result;
                        let page = query.page;

                        let categories = rows;
                        if(categories.length === 0) {
                            page = 0;

                            // if (rows && rows.length !== 0) {
                            if (count !== 0) {
                                const resultFirstPage = await getPaginateCategories({...query, page });

                                categories = resultFirstPage.rows;
                            }
                        }

                        resolve({
                            data: categories,
                            page: page,
                            totalCount: count,
                        })
                    } catch (err) {
                        resolve({
                            data: [],
                            page: 0,
                            totalCount: 0,
                        })
                    }
                })
            }
            actions={[
                {
                    icon: "visibility",
                    tooltip: "View Category",
                    onClick: (event, category) => onViewCategory(category)
                },
                {
                    icon: "edit",
                    tooltip: "Edit Category",
                    onClick: (event, category) => onEditCategory(category)
                },
                {
                    icon: "delete",
                    tooltip: "Delete Category",
                    onClick: (event, category) => onDeleteCategory(category.id)
                }
            ]}
            options={{
                actionsColumnIndex: -1,
                pageSize,
                emptyRowsWhenPaging: false
            }}
        />
    );
};

List.postTypes = {
    category: PropTypes.object.isRequired,
    getPaginateCategories: PropTypes.func.isRequired,
    updateModalContent: PropTypes.func.isRequired,
    toggleModal: PropTypes.func.isRequired,
    deleteCategory: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    category: state.admin.category
});

export default connect(mapStateToProps, {
    getPaginateCategories,
    toggleModal,
    updateModalContent,
    deleteCategory
})(List);
